<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.edit_feature_data") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #446e80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Image Upload -->
          <base-image-upload-input
            col="12"
            identifier="feature_image"
            :placeholder="$t('PLACEHOLDERS.feature_image')"
            :preSelectedImage="data.image.path"
            @selectImage="selectImage"
          />
          <!-- End:: Image Upload -->

          <!-- Start:: Name AR Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            required
          />
          <!-- End:: Name AR Input -->

          <!-- Start:: Name EN Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            required
          />
          <!-- End:: Name EN Input -->

          <!-- Start:: Description AR Input -->
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionAr')"
            v-model.trim="data.description_ar"
            required
          />
          <!-- End:: Description AR Input -->

          <!-- Start:: Description EN Input -->
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.descriptionEn')"
            v-model.trim="data.description_en"
            required
          />
          <!-- End:: Description EN Input -->

          <!-- Start:: Activation Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="
                data.is_active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.is_active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Activation Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "EditFeature",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        name_ar: null,
        name_en: null,
        description_ar: null,
        description_en: null,
        is_active: true,
      },
      // End:: Data Collection To Send
    };
  },

  methods: {
    // Start:: Select Upload Image
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    // End:: Select Upload Image,

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!this.data.name_ar) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name_ar"));
        return;
      }
      if (!this.data.name_en) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name_en"));
        return;
      }
      if (!this.data.description_ar) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.description_ar"));
        return;
      }
      if (!this.data.description_en) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.description_en"));
        return;
      }
      if (this.data.name_ar.length < 3 || this.data.name_ar.length > 50) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name_ar_length"));
        return;
      }
      if (this.data.name_en.length < 3 || this.data.name_en.length > 50) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name_en_length"));
        return;
      }
      if (
        this.data.description_ar.length < 3 ||
        this.data.description_ar.length > 500
      ) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.description_ar_length"));
        return;
      }
      if (
        this.data.description_en.length < 3 ||
        this.data.description_en.length > 500
      ) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.description_en_length"));
        return;
      }

      this.submitForm();
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();

      // Start:: Append Request Data
      REQUEST_DATA.append("name[ar]", this.data.name_ar);
      REQUEST_DATA.append("name[en]", this.data.name_en);
      REQUEST_DATA.append("description[ar]", this.data.description_ar);
      REQUEST_DATA.append("description[en]", this.data.description_en);
      REQUEST_DATA.append("is_active", this.data.is_active ? 1 : 0);

      if (this.data.image.file != null) {
        REQUEST_DATA.append("image", this.data.image.file);
      }

      REQUEST_DATA.append("_method", "PUT");

      try {
        await this.$axios({
          method: "POST",
          url: `features/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/features/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    // Start:: Get Data
    async getData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `features/${this.$route.params.id}`,
        });
        this.data.name_ar = res.data.data?.data.name_ar;
        this.data.name_en = res.data.data?.data.name_en;
        this.data.description_ar = res.data.data?.data.description_ar;
        this.data.description_en = res.data.data?.data.description_en;
        this.data.image.path = res.data.data?.data.image;
        this.data.created_at = res.data.data?.data.created_at;
        this.data.is_active = res.data.data?.data.is_active;
      } catch (error) {
        console.log(error?.response?.data?.message);
      }
    },
    // End:: Get Data
  },

  created() {
    this.getData();
  },
};
</script>
